// ABOUTME: Measures the top edge of the runner plate (the card), or undefined when no plate is in the document.
// ABOUTME: Re-measures when the plate resizes, on window resize, and when the body's children change so a late plate is found.
import { useLayoutEffect, useState } from 'react';

const PLATE = '[data-testid="runner-plate"]';

export function useStackPlateTop(): number | undefined {
  const [plateTop, setPlateTop] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(() => measure());
    let observed: Element | null = null;

    function measure() {
      const plate = document.querySelector(PLATE);
      if (plate !== observed) {
        if (observed) resizeObserver.unobserve(observed);
        if (plate) resizeObserver.observe(plate);
        observed = plate;
      }
      const top = plate ? plate.getBoundingClientRect().top : undefined;
      setPlateTop((previous) => (previous === top ? previous : top));
    }

    const mutationObserver = new MutationObserver(measure);
    measure();
    mutationObserver.observe(document.body, { childList: true });
    window.addEventListener('resize', measure);
    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return plateTop;
}
